"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDocumentSettingsOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M20.26 15.88L18.4 17a3.49 3.49 0 00-1.4-.8V14h-2v2.16a3.56 3.56 0 00-1.4.8l-1.86-1.08-1 1.74 1.86 1.07a3.33 3.33 0 000 1.62l-1.86 1.07 1 1.74L13.6 22a3.56 3.56 0 001.4.8V25h2v-2.16a3.49 3.49 0 001.4-.8l1.86 1.08 1-1.74-1.86-1.07a3.33 3.33 0 000-1.62l1.86-1.07zM16 21a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0116 21z" }),
        React.createElement("path", { d: "M17.37 2H6v28h20V10.58zM18 5.45L22.58 10H18zM8 28V4h8v8h8v16z" })));
}
exports.default = SvgDocumentSettingsOutline;
//# sourceMappingURL=DocumentSettingsOutline.js.map